import { UPDATE_SEARCHTDATA_NGUONVON } from "../../actions/NguonVon/actionTypes";

const initialState = {
  ten: "",
  loaigiaodich: 0,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchNguonVon = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_NGUONVON:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchNguonVon;
